// src/pages/ForgotPasswordPage.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getRedirectFromSearch, withRedirect } from "../../utils/authRedirect";
import "../css/LoginPage.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    // "Torna al login" conserva la pagina richiesta prima del login
    const location = useLocation();
    const loginTo = withRedirect("/login", getRedirectFromSearch(location.search));

    const isEmail = (v = "") =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setError("");

        const trimmed = email.trim();
        if (!isEmail(trimmed)) {
            setError("Inserisci un'email valida");
            return;
        }

        try {
            setLoading(true);
            const res = await fetch(
                `${API_BASE}/api/auth/request-password-reset`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: trimmed }),
                }
            );
            await res.json().catch(() => ({}));
            setDone(true);
        } catch {
            setError("Errore di rete");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-topbar">
                <div className="login-topbar-inner">
                    <img
                        src="/logo.png"
                        alt="StirUp logo"
                        className="login-logo"
                        width={64}
                        height={64}
                    />
                    <h1 className="login-topbar-title">
                        STIRUP: PIATTAFORMA DI STIRO CON RITIRO E CONSEGNA A DOMICILIO
                    </h1>
                </div>
            </div>

            <div className="login-hero">
                <div className="login-hero-inner">
                    <form className="login-card" onSubmit={handleSubmit} noValidate>
                        <h2 className="login-card-title">Recupero password</h2>
                        <p className="login-card-subtitle">
                            Inserisci la tua email e, se presente, riceverai un link per
                            reimpostare la password.
                        </p>

                        <div className="login-fields-frame">
                            {!done ? (
                                <>
                                    <div className="login-field">
                                        <label htmlFor="email" className="login-label">
                                            Email *
                                        </label>
                                        <input
                                            id="email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            autoComplete="email"
                                            className="input login-input"
                                        />
                                    </div>

                                    <div className="login-actions">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            aria-busy={loading}
                                            className="btn login-btn-outline"
                                        >
                                            {loading ? "Invio…" : "Invia link"}
                                        </button>
                                    </div>

                                    <div className="login-bottom-row">
                                        <Link to={loginTo} className="login-forgot">
                                            Torna al login
                                        </Link>
                                    </div>

                                    {error && (
                                        <div className="login-error-box" role="alert">
                                            {error}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            margin: "6px 0 8px",
                                            fontSize: 22,
                                        }}
                                    >
                                        📨
                                    </div>
                                    <p
                                        style={{
                                            margin: "6px 0 0",
                                            fontSize: 16,
                                            color: "#222",
                                            textAlign: "center",
                                        }}
                                    >
                                        Se l’email esiste, ti abbiamo inviato un link per reimpostare
                                        la password.
                                    </p>
                                    <p
                                        style={{
                                            margin: "8px 0 0",
                                            fontSize: 13,
                                            color: "#666",
                                            textAlign: "center",
                                        }}
                                    >
                                        Controlla la posta in arrivo (e la cartella spam).
                                    </p>
                                    <div className="login-actions">
                                        <Link
                                            to={loginTo}
                                            className="btn login-btn-outline"
                                        >
                                            Torna al login
                                        </Link>
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>

            <footer className="login-footer">
                <p className="login-payoff">
                    Stirup: piattaforma di stiro con ritiro e consegna a domicilio
                </p>
            </footer>
        </div>
    );
}
